import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'yesNo',
    standalone: true
})
export class YesNoPipe implements PipeTransform {

  transform(value: boolean | null | undefined ): string {
    if (value !== undefined && value !== null) {
      return value ? 'Ja' : 'Nein';
    }
    return '-';
  }

}
